import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';
import { ModuleComponentsPayload } from '../../../types/Content';

export enum ModuleComponentItemSource {
  GENERATED = 'GENERATED',
  CONTENT_SELECTOR = 'CONTENT_SELECTOR',
}

export interface ModuleComponentItem {
  type: string;
  label: string;
  direct?: boolean;
  id: string;
  key?: string;
  icon?: React.ReactNode;
  placeholder?: string;
  className?: string;
  source: ModuleComponentItemSource;
  wasAdded?: boolean;
  order?: number;
  name?: string;
  code?: string;
  loading?: boolean;
  error?: boolean;
  errorMessage?: string;
  retryParams?: ModuleComponentsPayload;
  isDeleting?: boolean;
  isInstantGeneration?: boolean;
  loadingText?: string;
}

export const moduleComponentItemsStateSegment = stateSegmentWithReset<
  ModuleComponentItem[]
>([]);

moduleComponentItemsStateSegment.debugLabel =
  'moduleComponentItemsStateSegment';
